export const DEFAULT_MOVE_PASSENGER_DATA = {
  events: {},
  locationsSchedule: {},
  resources: {},
  resourcesList: [],
  days: {},
  daysList: []
};

export const CONFIRM_PASSENGER_MOVE = 'CONFIRM_PASSENGER_MOVE';
